import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router";
import ProductOptionApprovalContainer from "~/containers/ProductOptionApprovalContainer";
import { getUserSlug } from "~/util/getUserSlug";

export default class ProductOptionApproval extends React.Component<
  RouteComponentProps<{}>
> {
  public render() {
    if (!getUserSlug()) {
      return (
        <Redirect
          to={{
            pathname: "/auth",
            state: { from: this.props.location }
          }}
        />
      );
    }

    return <ProductOptionApprovalContainer />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProductOptionApproval.tsx